export class BaseService {
  mockRequest = process.env.VUE_APP_API_AVAILABLE !== 'true';
}
